import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PeriodUtilService} from '@shared/services/util/period-util.service';
import {CalendarUtilsService} from '@shared/services';
import moment, {Moment} from 'moment-timezone';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-time-lapsed',
  templateUrl: './time-lapsed.component.html',
  styleUrls: ['./time-lapsed.component.scss'],
  standalone: false
})
export class TimeLapsedComponent implements OnChanges {
  @Input() timestamp: Moment;
  @Input() classNames: NgClass['ngClass'];
  @Input() abbreviated = true;

  private readonly browserTimezone: string = moment.tz.guess();

  timeLapsed: string;
  formattedTimeLapsed: string;

  constructor(private periodUtilService: PeriodUtilService,
              private calendarUtilsService: CalendarUtilsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.timestamp || changes.abbreviated) {
      this.timeLapsed = this.abbreviated
        ? this.periodUtilService.timeAgoAbbreviated(this.timestamp)
        : this.periodUtilService.timeAgo(this.timestamp);
      this.formattedTimeLapsed = this.calendarUtilsService.convertMomentToDisplayString(this.timestamp, this.browserTimezone) ?? null;
    }
  }
}
